/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Settings_Save_ErrorInputs */

const vi_smartlab_settings_save_error = /** @type {(inputs: Smartlab_Settings_Save_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu cấu hình SmartLab thất bại`)
};

/**

* @param {Smartlab_Settings_Save_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_settings_save_error = /** @type {((inputs?: Smartlab_Settings_Save_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Settings_Save_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_settings_save_error(inputs)
});